function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-ticket_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  filter: "url(#atoms-icon-ticket_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M14.383 8.31c.386-.386.397-1 .025-1.372l-1.57-1.57-.466.465a.647.647 0 01-.914.016.647.647 0 01.017-.914l.465-.465-1.57-1.57c-.372-.372-.986-.361-1.371.024L2.617 9.306c-.386.386-.397 1-.025 1.371l1.57 1.571.466-.465a.647.647 0 01.914-.017.647.647 0 01-.017.914l-.465.466 1.57 1.57c.372.372.986.36 1.371-.025l6.382-6.382zm-.448-.45l-6.382 6.382a.324.324 0 01-.457.009l-1.122-1.122c.513-.513.528-1.333.033-1.828-.495-.495-1.315-.48-1.828.033l-1.122-1.122a.324.324 0 01.008-.457l6.382-6.382a.324.324 0 01.457-.008l1.122 1.121c-.513.514-.528 1.334-.033 1.829.495.495 1.315.48 1.828-.034l1.122 1.122a.324.324 0 01-.008.457zm-2.41.615a.485.485 0 00.012-.685L9.518 5.77a.485.485 0 00-.686.013L5.475 9.14a.485.485 0 00-.012.686l2.019 2.019c.186.186.493.18.686-.012l3.357-3.358zm-.565-.332l-3.125 3.124L6.04 9.472l3.125-3.124 1.795 1.795z",
  fill: "#212121",
  fillRule: "nonzero"
}));

function SvgAtomsIconTicketinline(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgAtomsIconTicketinline;